import { currentUserSelector } from '@hefe/store';
import { Tabs, Tooltip } from 'antd';
import { t } from '@hefe/i18n';
import { useSelector } from 'react-redux';
import UserSettingsInterfacesComponent from '../../components/user-settings-interfaces/user-settings-interfaces.component';
import UserSettingsNotificationsComponent from '../../components/user-settings-notifications/user-settings-notifications.component';
import UserSettingsSettingsComponent from '../../components/user-settings-settings/user-settings-settings.component';
import { clubHasSubscription, userHasRole } from '@hefe/utils';
import { AuthRoles, AuthSubscriptions } from '@hefe/auth';

export default function UserSettingsPage() {
  const user = useSelector(currentUserSelector);

  if (!user) {
    return null;
  }

  const interfacesAllowed = clubHasSubscription(AuthSubscriptions.second, user);
  const userIsAdmin = userHasRole(AuthRoles.bbadmin, user);

  return (
    <Tabs>
      <Tabs.TabPane key="settings" tab={t('settings.title')}>
        <UserSettingsSettingsComponent />
      </Tabs.TabPane>
      <Tabs.TabPane key="notifications" tab={t('notifications.plural')}>
        <UserSettingsNotificationsComponent />
      </Tabs.TabPane>
      {(interfacesAllowed || userIsAdmin) && (
        <Tabs.TabPane
          key="interfaces"
          tab={
            interfacesAllowed ? (
              t('interfaces')
            ) : (
              <Tooltip title={t('errors.permissions.second')}>
                {t('interfaces')}
              </Tooltip>
            )
          }
          disabled={!interfacesAllowed}
        >
          <UserSettingsInterfacesComponent />
        </Tabs.TabPane>
      )}
    </Tabs>
  );
}
